import { LogoProps } from './types';

const QodoAnteaterSkateboard = ({ className = '', size = 180 }: LogoProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 181 191"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_293_225)">
      <path
        d="M49.5865 30.3105L12.6641 40.6771"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.2285 177.348L22.1084 188.15"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6106 173.008L0.572266 184.259"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M159.033 58.7032L164.094 58.9616L159.781 54.9075L165.06 54.7987L159.441 50.7174L165.087 50.867L156.094 45.4116"
        fill="white"
      />
      <path
        d="M159.033 58.7032L164.094 58.9616L159.781 54.9075L165.06 54.7987L159.441 50.7174L165.087 50.867L156.094 45.4116"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.346 36.582C120.495 36.5548 164.696 34.2692 159.037 58.7028C159.037 58.7028 121.679 53.3971 117.652 55.3561L112.727 42.2686L120.346 36.582Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M159.04 58.7032C159.04 58.7032 155.761 58.2407 151.027 57.6285L153.653 43.4526C158.115 46.7585 160.686 51.5881 159.04 58.7032Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M67.2457 94.2245C68.2524 97.2175 -7.22497 112.536 18.6643 156.9L26.0651 146.738L30.1464 152.778L37.6289 142.983L40.9483 149.105L47.3288 139.187L51.6958 145.16L58.8518 136.412L62.5794 141.364L69.0007 132.793L72.8643 137.514L78.9455 128.344L67.2185 94.2109L67.2457 94.2245Z"
        fill="black"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M112.431 36.0923C112.431 36.0923 82.3926 25.9162 73.849 28.8683C69.686 30.3104 68.7337 32.8272 67.6045 36.5412C66.4618 40.2552 64.0538 44.3366 64.0538 44.3366L66.5706 54.0773V64.199C66.5706 64.199 51.3608 118.263 76.325 128.222C83.1544 131.432 111.098 126.63 121.22 115.923L122.267 93.4214C122.526 93.6118 127.124 73.0555 124.798 49.5063L112.445 36.0787L112.431 36.0923Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.639 54.8259C111.639 54.8259 100.021 45.2892 71.2749 43.4526"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.815 54.0913C117.815 54.0913 131.406 47.6156 128.005 40.0107C127.243 38.3101 125.393 37.1265 123.189 36.6504"
        fill="#7A68FA"
      />
      <path
        d="M117.815 54.0913C117.815 54.0913 131.406 47.6156 128.005 40.0107C127.243 38.3101 125.393 37.1265 123.189 36.6504"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M114.293 49.4928C114.293 49.4928 120.456 46.7039 122.755 41.5342"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.7817 102.985C62.7817 102.985 86.4262 106.359 108.833 100.346C131.239 94.3331 134.477 109.774 134.477 109.774C134.477 109.774 140.109 121.8 136.191 123.827C131.362 126.331 116.751 118.957 116.451 119.134C115.893 119.447 112.724 121.433 109.812 122.671C106.942 123.936 104.683 124.603 104.683 124.603L76.5086 127.664C76.5086 127.664 71.0668 126.276 67.1079 119.229C63.2987 112.481 62.7817 102.985 62.7817 102.985Z"
        fill="white"
      />
      <path
        d="M114.69 110.671C114.69 110.671 113.492 126.439 128.689 124.48C128.689 124.48 126.444 133.813 129.655 134.724C133.491 134.139 150.347 123.487 146.47 118.698C142.96 114.345 136.103 120.711 134.987 123.174"
        fill="white"
      />
      <path
        d="M114.69 110.671C114.69 110.671 113.492 126.439 128.689 124.48C128.689 124.48 126.444 133.813 129.655 134.724C133.491 134.139 150.347 123.487 146.47 118.698C142.96 114.345 136.103 120.711 134.987 123.174"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.8726 102.877C61.8726 102.877 78.0482 106.359 109.991 100.128"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M121.689 62.2677C122.117 62.2677 122.464 61.9205 122.464 61.4922C122.464 61.064 122.117 60.7168 121.689 60.7168C121.26 60.7168 120.913 61.064 120.913 61.4922C120.913 61.9205 121.26 62.2677 121.689 62.2677Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.705 50.4448C119.705 50.4448 121.419 58.2266 121.582 61.1515L119.705 50.4448Z"
        fill="white"
      />
      <path
        d="M119.705 50.4448C119.705 50.4448 121.419 58.2266 121.582 61.1515"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8691 72.389L19.618 74.28L25.9984 69.1103L18.6521 69.7497L25.7808 65.1514L17.9038 65.9677L26.4474 61.8184"
        fill="white"
      />
      <path
        d="M26.8691 72.389L19.618 74.28L25.9984 69.1103L18.6521 69.7497L25.7808 65.1514L17.9038 65.9677L26.4474 61.8184"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.9836 43.8197C56.5969 43.5204 20.1506 51.4246 26.8712 72.389C26.8712 72.389 55.3725 64.3896 68.7184 65.1786"
        fill="#7A68FA"
      />
      <path
        d="M69.9836 43.8197C56.5969 43.5204 20.1506 51.4246 26.8712 72.389C26.8712 72.389 55.3725 64.3896 68.7184 65.1786"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M133.489 6.78861C133.489 6.78861 133.897 2.62565 134.169 1.75496C134.441 0.88428 135.434 -1.15639 137.842 -0.258493C140.25 0.6394 139.597 3.04739 139.216 3.67319C138.835 4.29899 136.645 8.18986 136.645 8.18986"
        fill="white"
      />
      <path
        d="M133.489 6.78861C133.489 6.78861 133.897 2.62565 134.169 1.75496C134.441 0.88428 135.434 -1.15639 137.842 -0.258493C140.25 0.6394 139.597 3.04739 139.216 3.67319C138.835 4.29899 136.645 8.18986 136.645 8.18986"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M174.545 41.9281L168.396 45.3701C168.709 45.887 121.76 15.6716 121.121 43.9008C121.121 43.9008 118.74 47.4651 114.291 49.5058C114.291 49.5058 93.3948 37.6563 83.3683 35.2484L83.3275 35.2211L79.3686 33.7791L78.9604 33.4254C78.9604 33.4254 97.5033 -0.558516 127.243 4.14862C156.995 8.84215 174.545 41.9281 174.545 41.9281Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.658 16.5026C126.658 16.5026 127.556 16.9651 127.638 18.1351C127.719 19.3051 127.855 23.2776 133.039 22.8831C138.222 22.4885 137.827 18.8017 137.596 15.7407"
        fill="black"
      />
      <path
        d="M126.658 16.5026C126.658 16.5026 127.556 16.9651 127.638 18.1351C127.719 19.3051 127.855 23.2776 133.039 22.8831C138.222 22.4885 137.827 18.8017 137.596 15.7407"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M153.012 14.5293C153.012 14.5293 152.195 15.1279 152.291 16.2843C152.386 17.4406 152.835 21.3995 147.665 21.7805C142.496 22.1614 142.319 18.461 142.087 15.4"
        fill="black"
      />
      <path
        d="M153.012 14.5293C153.012 14.5293 152.195 15.1279 152.291 16.2843C152.386 17.4406 152.835 21.3995 147.665 21.7805C142.496 22.1614 142.319 18.461 142.087 15.4"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.336 16.4478L154.287 14.2847"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M142.495 16.815C142.44 16.1348 141.665 15.3457 139.896 15.4818C138.128 15.6178 137.339 16.5293 137.379 17.1959"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.588 7.40064C116.588 7.40064 113.54 4.14918 113.037 3.31931C112.534 2.48944 111.595 0.258308 114.003 -1.03411C116.411 -2.32653 117.894 -0.109012 118.111 0.625628C118.329 1.36027 119.921 5.84973 119.921 5.84973"
        fill="white"
      />
      <path
        d="M116.588 7.40064C116.588 7.40064 113.54 4.14918 113.037 3.31931C112.534 2.48944 111.595 0.258308 114.003 -1.03411C116.411 -2.32653 117.894 -0.109012 118.111 0.625628C118.329 1.36027 119.921 5.84973 119.921 5.84973"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.3323 107.189C70.6724 105.149 90.5077 80.3343 104.044 100.142C119.444 122.685 94.9699 142.928 80.3587 131.052C80.3587 131.052 72.0056 125.243 73.0532 113.964"
        fill="white"
      />
      <path
        d="M70.3323 107.189C70.6724 105.149 90.5077 80.3343 104.044 100.142C119.444 122.685 94.9699 142.928 80.3587 131.052C80.3587 131.052 72.0056 125.243 73.0532 113.964"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.5286 130.52C85.8965 118.127 90.5764 111.923 94.1952 113.692C100.63 116.821 103.269 133.473 101.065 135.949C98.6439 138.071 95.4196 133.255 93.5286 130.534V130.52Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.761 101.285C108.727 99.9384 120.59 83.6947 133.283 89.7759C142.302 94.6463 144.615 112.101 135.214 121.039"
        fill="white"
      />
      <path
        d="M107.761 101.285C108.727 99.9384 120.59 83.6947 133.283 89.7759C142.302 94.6463 144.615 112.101 135.214 121.039"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M174.545 41.9288L168.409 45.3707C168.477 45.4795 166.641 44.3367 163.661 42.6906L172.205 37.9971C173.756 40.4187 174.559 41.9288 174.559 41.9288H174.545Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.3313 36.4329C80.2978 34.2834 75.8628 32.3516 75.8628 32.3516L87.3313 36.4329Z"
        fill="#7A68FA"
      />
      <path
        d="M87.3313 36.4329C80.2978 34.2834 75.8628 32.3516 75.8628 32.3516"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M118.616 86.415C118.208 86.5647 117.895 86.5375 117.636 86.347C117.378 86.1566 117.228 85.7892 117.16 85.2723L115.813 75.1642L116.14 75.0417C116.017 76.6062 115.527 78.0075 114.698 79.2183C113.868 80.4291 112.793 81.2862 111.46 81.7759C110.126 82.2657 108.956 82.2657 107.868 81.8167C106.78 81.3678 105.882 80.5107 105.147 79.2455C104.413 77.9803 103.923 76.3478 103.651 74.3479C103.379 72.3481 103.419 70.4842 103.76 68.8245C104.1 67.1648 104.698 65.7635 105.569 64.6071C106.44 63.4644 107.528 62.6481 108.834 62.1719C110.14 61.6958 111.364 61.6958 112.439 62.2264C113.514 62.7433 114.303 63.682 114.82 65.0425L114.562 65.7091L114.072 62.0087C114.004 61.4917 114.058 61.0564 114.235 60.7027C114.412 60.3489 114.684 60.1041 115.065 59.968C115.473 59.8184 115.786 59.8456 116.031 60.0496C116.262 60.2537 116.425 60.6074 116.493 61.1244L119.582 84.388C119.65 84.9049 119.595 85.3403 119.418 85.694C119.241 86.0477 118.969 86.2926 118.588 86.4286L118.616 86.415ZM111.664 79.055C112.575 78.7285 113.324 78.1435 113.936 77.3273C114.548 76.511 114.956 75.4771 115.187 74.2527C115.419 73.0283 115.432 71.6542 115.228 70.1169C114.915 67.7634 114.262 66.1036 113.283 65.1513C112.303 64.199 111.12 63.9813 109.732 64.4983C108.807 64.8384 108.045 65.4098 107.446 66.2125C106.848 67.0151 106.426 68.0218 106.208 69.2326C105.977 70.4434 105.964 71.8447 106.181 73.4228C106.494 75.7628 107.147 77.4089 108.14 78.3612C109.133 79.3135 110.317 79.5448 111.677 79.0414L111.664 79.055Z"
        fill="white"
      />
      <path
        d="M107.613 51.4653C107.613 51.4653 108.552 58.4716 107.926 62.7026L107.613 51.4653Z"
        fill="white"
      />
      <path
        d="M107.613 51.4653C107.613 51.4653 108.552 58.4716 107.926 62.7026"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.939 63.6412C108.367 63.6412 108.714 63.2941 108.714 62.8658C108.714 62.4375 108.367 62.0903 107.939 62.0903C107.51 62.0903 107.163 62.4375 107.163 62.8658C107.163 63.2941 107.51 63.6412 107.939 63.6412Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.3851 54.5405L35.3306 70.2128C35.1537 70.2536 34.9768 70.2945 34.8136 70.3489C30.8819 71.274 27.9978 72.0766 27.1271 72.3351C26.9502 72.3759 26.855 72.4031 26.855 72.4031C26.787 72.1719 26.7189 71.9406 26.6509 71.7229C26.5965 71.5053 26.5285 71.3012 26.4877 71.0971C24.8143 64.1453 27.9842 58.6899 33.3851 54.5541V54.5405Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.4831 150.669C98.7679 146.615 143.037 128.059 145.594 126.916C148.152 125.773 153.118 124.712 159.743 117.393C166.464 109.611 176.817 111.08 179.429 119.352C182.258 128.317 178.041 137.419 170.681 142.833C170.681 142.833 162.777 148.928 153.907 153.295C145.037 157.662 100.496 173.742 97.8428 174.763C95.1899 175.783 84.6601 179.171 78.5789 178.98C72.4977 178.79 64.7432 176.613 62.5937 168.559C58.4579 153.105 79.4088 153.009 86.4967 150.669H86.4831Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M163.761 151.145C161.408 147.785 159.762 145.35 159.762 145.35L151.368 151.24C151.368 151.24 153.558 154.342 155.422 156.995C157.286 159.648 165.584 153.744 163.761 151.145Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M156.805 150.07C159.126 148.446 160.466 146.356 159.799 145.402C159.131 144.448 156.708 144.99 154.387 146.614C152.067 148.238 150.726 150.328 151.394 151.282C152.062 152.237 154.484 151.694 156.805 150.07Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.003 145.704L154.112 148.615L155.989 146.847L153.54 143.568L152.003 145.704Z"
        fill="white"
      />
      <path
        d="M147.458 136.561L155.117 133.174L160.79 140.452L152.505 143.908"
        fill="white"
      />
      <path
        d="M147.458 136.561L155.117 133.174L160.79 140.452L152.505 143.908"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.971 142.194L156.277 146.996C156.277 146.996 156.807 147.554 155.705 148.356C154.603 149.159 154.1 148.683 154.1 148.683L146.128 137.691L148.413 136.14L151.189 139.894L153.528 137.31L155.147 139.473L152.984 142.194H152.971Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.923 132.126C147.569 128.766 145.923 126.331 145.923 126.331L137.529 132.221C137.529 132.221 139.72 135.323 141.583 137.976C143.447 140.642 151.746 134.724 149.923 132.126Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.095 131.212C145.416 129.588 146.704 127.423 145.972 126.377C145.24 125.33 142.764 125.798 140.444 127.422C138.123 129.046 136.835 131.211 137.567 132.257C138.299 133.304 140.774 132.836 143.095 131.212Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M140.387 130.031C141.326 129.745 142.183 129.201 142.904 128.276L140.387 130.031Z"
        fill="white"
      />
      <path
        d="M140.387 130.031C141.326 129.745 142.183 129.201 142.904 128.276"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.4583 176.599C96.1048 173.239 94.4586 170.804 94.4586 170.804L86.0647 176.694C86.0647 176.694 88.255 179.796 90.1188 182.449C91.9826 185.116 100.281 179.198 98.4583 176.599Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M91.5147 175.513C93.8356 173.889 95.1758 171.799 94.5081 170.845C93.8405 169.891 91.4178 170.434 89.0969 172.058C86.776 173.682 85.4358 175.772 86.1034 176.726C86.7711 177.68 89.1938 177.137 91.5147 175.513Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.7129 171.157L88.808 174.068L90.6854 172.3L88.2502 169.021L86.7129 171.157Z"
        fill="white"
      />
      <path
        d="M82.1675 162.015L89.8132 158.627L95.4998 165.906L87.2011 169.361"
        fill="white"
      />
      <path
        d="M82.1675 162.015L89.8132 158.627L95.4998 165.906L87.2011 169.361"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.6846 167.647L90.9905 172.45C90.9905 172.45 91.521 173.007 90.4191 173.81C89.3171 174.613 88.8138 174.137 88.8138 174.137L80.8416 163.144L83.1271 161.593L85.9024 165.348L88.2424 162.763L89.8613 164.926L87.6982 167.647H87.6846Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.62 157.58C82.2664 154.22 80.6203 151.785 80.6203 151.785L72.2263 157.675C72.2263 157.675 74.4166 160.777 76.2804 163.43C78.1442 166.097 86.443 160.179 84.62 157.58Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.7882 156.677C80.1091 155.053 81.3969 152.888 80.6647 151.841C79.9324 150.795 77.4573 151.263 75.1364 152.887C72.8155 154.511 71.5277 156.676 72.26 157.722C72.9922 158.769 75.4673 158.301 77.7882 156.677Z"
        fill="#7A68FA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.0967 155.485C76.0354 155.2 76.8925 154.656 77.6135 153.73L75.0967 155.485Z"
        fill="white"
      />
      <path
        d="M75.0967 155.485C76.0354 155.2 76.8925 154.656 77.6135 153.73"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_225">
        <rect width="180.871" height="190.707" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default QodoAnteaterSkateboard;
